/* assets/cls-debug.js */
(function (w, d) {
  'use strict';

  // -----------------------------
  // Helpers / config
  // -----------------------------
  function qsHas(flag) {
    try {
      return new RegExp('(?:\\?|&)' + flag + '=1(?:&|$)').test(w.location.search);
    } catch (e) {
      return false;
    }
  }

  function lsGet(key) {
    try {
      return w.localStorage ? w.localStorage.getItem(key) : null;
    } catch (e) {
      return null;
    }
  }

  function nowMs() {
    try {
      return w.performance && w.performance.now ? w.performance.now() : Date.now();
    } catch (e) {
      return Date.now();
    }
  }

  function round(n, dp) {
    var p = Math.pow(10, dp || 0);
    return Math.round(n * p) / p;
  }

  // Prefer explicit liquid-provided page type if you add it; otherwise infer from body classes.
  function getPageType() {
    if (w.__pksPageType) return w.__pksPageType;
    var b = d.body;
    if (!b || !b.classList) return '';
    if (b.classList.contains('template-collection')) return 'collection';
    if (b.classList.contains('template-search')) return 'search';
    return '';
  }

  function isMobile749() {
    try {
      return w.matchMedia && w.matchMedia('(max-width: 749px)').matches;
    } catch (e) {
      return false;
    }
  }

  // Debug toggles:
  // - CLS logging:    ?clsdebug=1 OR localStorage CLS_DEBUG=1
  // - DOM watch:      ?clsWatch=1 OR localStorage CLS_WATCH=1
  // - SS max height:  ?ssdebug=1 (matches what you already do)
  // - Disable SS fix: ?ssfix=0
  // - Test fix locks: ?pksfix=1 OR localStorage PKS_FIX=1
  var FLAGS = {
    clsDebug: qsHas('clsdebug') || lsGet('CLS_DEBUG') === '1',
    clsWatch: qsHas('clsWatch') || lsGet('CLS_WATCH') === '1',
    ssDebug:  qsHas('ssdebug'),
    ssFixOff: false,
    pksFix:   qsHas('pksfix') || lsGet('PKS_FIX') === '1'
  };

  // Allow ?ssfix=0
  try {
    if (/(?:\?|&)ssfix=0(?:&|$)/.test(w.location.search)) FLAGS.ssFixOff = true;
  } catch (e) {}

  function log() {
    if (!FLAGS.clsDebug && !FLAGS.clsWatch && !FLAGS.ssDebug && !FLAGS.pksFix) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[PKS CLS ' + Math.round(nowMs()) + 'ms]');
      console.log.apply(console, args);
    } catch (e) {}
  }

  function warn() {
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[PKS CLS ' + Math.round(nowMs()) + 'ms]');
      console.warn.apply(console, args);
    } catch (e) {}
  }

  // -----------------------------
  // CSS-ish path helper (yours, ES5-ified)
  // -----------------------------
  function cssPath(el) {
    if (!el || el.nodeType !== 1) return '';
    var parts = [];
    var depth = 0;

    while (el && el.nodeType === 1 && depth < 6) {
      var part = (el.nodeName || '').toLowerCase();
      if (!part) break;

      if (el.id) {
        part += '#' + el.id;
        parts.unshift(part);
        break;
      }

      var cls = (el.className || '').toString().trim().split(/\s+/);
      var out = [];
      for (var i = 0; i < cls.length && out.length < 2; i++) {
        if (cls[i]) out.push(cls[i]);
      }
      if (out.length) part += '.' + out.join('.');

      parts.unshift(part);
      el = el.parentElement;
      depth++;
    }

    return parts.join(' > ');
  }

  // -----------------------------
  // PKS Fix (test): banner/header height reservation
  // -----------------------------
  function lockStaticMinHeight(selector, px) {
    var start = nowMs();

    function apply() {
      var el = d.querySelector(selector);
      if (!el) {
        if (nowMs() - start < 8000) w.setTimeout(apply, 100);
        return;
      }
      try {
        el.style.minHeight = px + 'px';
        log('[FIX] static min-height', selector, px + 'px');
      } catch (e) {}
    }

    apply();
  }

  // Reserve banner height only after we observe it reach "real" size (prevents locking onto 80/92px).
  function reserveBannerMinHeight(selectors, minLockPx, opts) {
    opts = opts || {};
    var start = nowMs();
    var findMs = opts.findMs || 9000;
    var locked = false;
    var ro = null;

    function pickFirstExisting() {
      for (var i = 0; i < selectors.length; i++) {
        var el = d.querySelector(selectors[i]);
        if (el) return el;
      }
      return null;
    }

    function tick() {
      if (locked) return;

      var el = pickFirstExisting();
      if (!el || !el.getBoundingClientRect) {
        if (nowMs() - start < findMs) w.setTimeout(tick, 50);
        return;
      }

      var h = Math.round(el.getBoundingClientRect().height);

      // Only lock when we see a meaningful height close to the real banner (~185px).
      if (h >= (minLockPx || 150)) {
        locked = true;
        try { el.style.minHeight = h + 'px'; } catch (e) {}
        log('[FIX] lock banner min-height', h + 'px', 'on', selectors.join(' | '));

        // Keep min-height at the max observed height (never decreases).
        if (w.ResizeObserver) {
          var maxH = h;
          ro = new ResizeObserver(function () {
            if (!el || !el.getBoundingClientRect) return;
            var nh = Math.round(el.getBoundingClientRect().height);
            if (nh > maxH) {
              maxH = nh;
              try { el.style.minHeight = maxH + 'px'; } catch (e2) {}
              log('[FIX] bump banner min-height', maxH + 'px');
            }
          });
          ro.observe(el);
        }

        // Optional unlock (keep locked while debugging)
        if (opts.unlockMs) {
          w.setTimeout(function () {
            try { if (el) el.style.minHeight = ''; } catch (e3) {}
            try { if (ro) ro.disconnect(); } catch (e4) {}
            log('[FIX] unlock banner min-height');
          }, opts.unlockMs);
        }
        return;
      }

      if (nowMs() - start < findMs) w.setTimeout(tick, 50);
    }

    tick();
  }

  function initPksFix() {
    if (!FLAGS.pksFix) return;

    var pageType = getPageType();
    if (pageType !== 'collection' && pageType !== 'search') return;

    // Prevent the ~185px products bounce by reserving banner space once banner reaches real height.
    reserveBannerMinHeight(
      ['[id*="__main_collection_banner"]', '.cc-collection-banner'],
      150,
      { findMs: 9000, unlockMs: 0 } // keep locked while debugging
    );

    // Header grows later (~+40px). This is a quick stabilizer for the SS header region.
    lockStaticMinHeight(
      '#searchspring-header .ss__search-header, #searchspring-toolbar .ss__search-header, .ss__search-header',
      177
    );
  }

  // -----------------------------
  // 1) CLS PerformanceObserver (debug only)
  // -----------------------------
  function initLayoutShiftObserver() {
    if (!FLAGS.clsDebug) return;

    w.__clsEntries = w.__clsEntries || [];

    try {
      var po = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.hadRecentInput) continue;
          if (!entry.value || entry.value < 0.001) continue;

          var sourcesArr = [];
          var sources = entry.sources || [];
          for (var j = 0; j < sources.length; j++) {
            var s = sources[j];
            sourcesArr.push({
              node: cssPath(s.node),
              prev: s.previousRect,
              cur:  s.currentRect
            });
          }

          var rec = {
            value: round(entry.value, 4),
            startTimeMs: Math.round(entry.startTime),
            vp: { w: w.innerWidth, h: w.innerHeight, dpr: w.devicePixelRatio || 1 },
            sources: sourcesArr
          };

          w.__clsEntries.push(rec);
          if (w.__clsEntries.length > 200) w.__clsEntries.shift();

          console.log('[CLS]', JSON.stringify(rec));
        }
      });

      try {
        po.observe({ type: 'layout-shift', buffered: true });
      } catch (e1) {
        po.observe({ entryTypes: ['layout-shift'] });
      }

      log('LayoutShift observer enabled');
    } catch (e) {
      warn('LayoutShift observer not supported', e);
    }
  }

  // -----------------------------
  // 2) Mutation + attribute + size watch (debug only)
  // -----------------------------
  function initDomWatch() {
    if (!FLAGS.clsWatch) return;

    var targets = [
      'html',
      'body',
      '.cc-collection-banner',
      '.cc-collection-products',
      '#searchspring-header',
      '#searchspring-toolbar',
      '#searchspring-header .ss__search-header',
      '#searchspring-toolbar .ss__search-header',
      '.ss__search-header',
      '[id*="__main_collection_banner"]',
      '[id*="__collection-products"]'
    ];

    var attached = {}; // prevent duplicate observers on retry

    function snap(el) {
      var r = el.getBoundingClientRect();
      var cs = w.getComputedStyle(el);
      return {
        display: cs.display,
        visibility: cs.visibility,
        position: cs.position,
        height: Math.round(r.height),
        top: Math.round(r.top),
        className: el.className
      };
    }

    function attachMutation(sel) {
      if (attached[sel]) return true;

      var el = (sel === 'html') ? d.documentElement :
               (sel === 'body') ? d.body :
               d.querySelector(sel);

      if (!el) return false;

      attached[sel] = true;
      log('[WATCH]', sel, snap(el));

      var mo = new MutationObserver(function (muts) {
        var summary = [];
        for (var i = 0; i < muts.length; i++) {
          summary.push(muts[i].type + ':' + (muts[i].attributeName || ''));
        }
        log('[MUT]', sel, summary.join(', '));
        log('[SNAP]', sel, snap(el));
      });

      mo.observe(el, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
        childList: true,
        subtree: true
      });

      return true;
    }

    function watchAttrs(el, label) {
      if (!el) return;

      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var name = muts[i].attributeName;
          log('[ATTR]', label, name, el.getAttribute(name));
        }
      });

      mo.observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
    }

    function watchSizeRetry(sel, windowMs) {
        if (!w.ResizeObserver) return;

        var start = nowMs();
        var lastH = -1;
        var lastW = -1;

        function attach() {
            var el = d.querySelector(sel);
            if (!el) {
            if (nowMs() - start < (windowMs || 9000)) w.setTimeout(attach, 100);
            return;
            }

            var ro = new ResizeObserver(function () {
            if (!el || !el.getBoundingClientRect) return;
            var r = el.getBoundingClientRect();
            var h = Math.round(r.height);
            var ww = Math.round(r.width);

            if (h !== lastH || ww !== lastW) {
                lastH = h;
                lastW = ww;
                log('[SIZE]', sel, 'h=', h, 'w=', ww, 'vw=', w.innerWidth);
            }
            });

            ro.observe(el);
        }

        attach();
    }

    // Attr watchers (often the smoking gun)
    watchAttrs(d.documentElement, 'html');
    watchAttrs(d.body, 'body');

    // Size watchers
    watchSizeRetry('.cc-collection-banner');
    watchSizeRetry('.cc-collection-products');
    watchSizeRetry('#searchspring-header .ss__search-header');
    watchSizeRetry('#searchspring-toolbar .ss__search-header');
    watchSizeRetry('.ss__search-header');
    watchSizeRetry('#searchspring-toolbar'); // catches 0 -> 74px jump
    watchSizeRetry('custom-pagination, [data-testid="custom-pagination"], .custom-pagination'); // catches placeholder collapse
    watchSizeRetry('#searchspring-header');

    // Attach mutation observers (retry for late-inserted nodes)
    var start = nowMs();
    (function retry() {
      for (var i = 0; i < targets.length; i++) attachMutation(targets[i]);
      if (nowMs() - start < 15000) w.setTimeout(retry, 500);
    })();

    log('DOM watch enabled');
  }

  // -----------------------------
  // 3) Searchspring mobile fix (collection/search + mobile)
  // -----------------------------
  function initSearchspringMobileFix() {
    if (FLAGS.ssFixOff) return;

    var pageType = getPageType();
    if (pageType !== 'collection' && pageType !== 'search') return;
    if (!isMobile749()) return;

    // Mark loading ASAP so header "build" isn't visible
    try {
      d.documentElement.classList.add('ss-loading');
    } catch (e) {}

    var READY_TIMEOUT_MS = 15000;
    var start = nowMs();

    function getHeader() {
      return (
        d.querySelector('#searchspring-toolbar .ss__search-header') ||
        d.querySelector('#searchspring-header .ss__search-header') ||
        d.querySelector('.ss__search-header')
      );
    }

    function ensureTabsPlaceholder() {
      var header = getHeader();
      if (!header) return false;

      var realTabs = header.querySelector('.ss__tabs__buttons');
      var ph = header.querySelector('.ss__tabs__buttons--placeholder');

      if (realTabs) {
        if (ph && ph.parentNode) ph.parentNode.removeChild(ph);
        return true;
      }

      if (!ph) {
        var h1 = header.querySelector('h1');
        if (h1) {
          var spacer = d.createElement('div');
          spacer.className = 'ss__tabs__buttons ss__tabs__buttons--placeholder';
          spacer.setAttribute('aria-hidden', 'true');

          if (h1.insertAdjacentElement) {
            h1.insertAdjacentElement('afterend', spacer);
          } else if (h1.parentNode) {
            h1.parentNode.insertBefore(spacer, h1.nextSibling);
          }
        }
      }

      return false;
    }

    function isReady() {
      var header = getHeader();
      if (!header) return false;
      if (!header.querySelector('.ss__tabs__buttons')) return false;

      var resultsRoot = d.querySelector('.ss__results, .ss__results__grid, [data-ss-results]');
      if (!resultsRoot) return false;

      return true;
    }

    function done(reason) {
      try {
        d.documentElement.classList.remove('ss-loading');
      } catch (e) {}
      log('SS done:', reason || 'ok');
    }

    function debugMaxHeaderHeight() {
      if (!FLAGS.ssDebug) return;
      if (!w.ResizeObserver) return;

      var sel = '#searchspring-header .ss__search-header, #searchspring-toolbar .ss__search-header, .ss__search-header';
      var maxH = 0;

      function startRO(el) {
        var ro = new ResizeObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var h = Math.ceil(entries[i].contentRect.height);
            if (h > maxH) maxH = h;
          }
        });
        ro.observe(el);

        w.setTimeout(function () {
          ro.disconnect();
          log('[SS DEBUG] MAX header height during load:', maxH);
          w.__ssMaxHeaderH = maxH;
        }, 8000);
      }

      var el = d.querySelector(sel);
      if (el) return startRO(el);

      var mo2 = new MutationObserver(function () {
        var el2 = d.querySelector(sel);
        if (!el2) return;
        mo2.disconnect();
        startRO(el2);
      });

      mo2.observe(d.documentElement, { childList: true, subtree: true });
      w.setTimeout(function () { mo2.disconnect(); }, 8000);
    }

    debugMaxHeaderHeight();

    ensureTabsPlaceholder();
    if (isReady()) return done('already-ready');

    var mo = new MutationObserver(function () {
      ensureTabsPlaceholder();

      if (isReady()) {
        mo.disconnect();
        return done('ready');
      }

      if (nowMs() - start > READY_TIMEOUT_MS) {
        mo.disconnect();
        return done('timeout');
      }
    });

    mo.observe(d.documentElement, { childList: true, subtree: true });
    w.setTimeout(function () {
      try { mo.disconnect(); } catch (e) {}
      done('hard-timeout');
    }, READY_TIMEOUT_MS);

    log('SS mobile fix active on', pageType);
  }

  // -----------------------------
  // Boot (safe)
  // -----------------------------
  function safeCall(fn, name) {
    try { fn(); }
    catch (e) { warn(name + ' failed', e); }
  }

  safeCall(initPksFix, 'initPksFix');                    // enable with ?pksfix=1
  safeCall(initLayoutShiftObserver, 'initLayoutShiftObserver'); // enable with ?clsdebug=1
  safeCall(initDomWatch, 'initDomWatch');                // enable with ?clsWatch=1
  safeCall(initSearchspringMobileFix, 'initSearchspringMobileFix'); // mobile-only (disable with ?ssfix=0)

})(window, document);